import { lazy } from 'react'

export const UniquelyTailoredPlan = lazy(() => import('./UniquelyTailoredPlan'))
